import React from "react";
import { Box } from "@mui/system";

const SingleImageBox = (props) => {
  const { classNameProp = "" } = props;

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        // maxWidth: "20rem",
      }}
    >
      <img
        className={classNameProp}
        src={props.imgSrc}
        style={{ width: props?.width ? props.width : "20rem" }}
      />
    </Box>
  );
};

export default SingleImageBox;
